/* 
footPrintsStyle  "none" "rect" "ellipse"
satelliteStyle = "detailed" "cube"
color       cube style: applies color to cube.  detailed style: "gray" makes body & panels gray, all others make blue and gold.
satelliteSize
selectedBeam   footprintColorMode = selectd, then if 0-15 colors just that beam;  -1 colors none.
footprintColorMode "all" "selected"
*/

import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';
import { namespaceTypeNames } from '@awayfl/avm2/dist/lib/abc/lazy/NamespaceType';
//import SphericalSectionGeometry_geom from 'SATPROF_LIBRARY/ThreeDParts/SphericalSectionGeometry_geom';

export default class OneWebSatellite_grp  extends THREE.Group{
   

    private panels:THREE.Group;
    private footprintsRect:THREE.Group;
    private footprintsEllipse:THREE.Group;
    private _footPrintsStyle:string = "none";
    public footprintRect_m:Array<THREE.Mesh>;

    private _satelliteSize:number = 100;
    private body:THREE.Group;
    private satellite:THREE.Group;
    private cubeSat:THREE.Group;
    private cube_m:THREE.Mesh;
    private _satelliteStyle:string = "cube";
    private latRotGroup:THREE.Group;
    private longRotGroup:THREE.Group;
    private TA_deg:number = 0;
    private RAAN_deg:number = 0;
    private _nBeams:number = 16;
    private _selectedBeam:number = -1; // Default to none
    private _footprintColorMode:string = "all";  
    private footprintColorsMulti:Array<string>;
    private footprintColorsGray:Array<string>;
    private _satName:string = "";
    private panel1_m:THREE.Mesh;
    private panel2_m:THREE.Mesh;
    private body_m:THREE.Mesh;

    constructor(){
        super();
        //console.log("In OneWebSatellite constructor...")
        this.createObject();
    }
    
        
    private createObject(){

        this.longRotGroup = new THREE.Group();
        this.add(this.longRotGroup);

        this.latRotGroup = new THREE.Group();
        this.longRotGroup.add( this.latRotGroup)

        this.satellite = new THREE.Group();
        this.latRotGroup.add(this.satellite);

        this.footprintsRect = new THREE.Group();
        this.footprintsEllipse = new THREE.Group();
        this.latRotGroup.add(this.footprintsRect);
        this.latRotGroup.add(this.footprintsEllipse);

        //this.satellite.rotation.x = Math.PI/2;      
        let cube_g:THREE.BoxGeometry = new THREE.BoxGeometry(100,100,100);
        let cube_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial( { color: "red" } );
        this.cube_m =  new THREE.Mesh(cube_g, cube_mat);
        this.cubeSat = new THREE.Group();
        this.cubeSat.add(this.cube_m);

        this.satellite.add(this.cubeSat);

        this.body = new THREE.Group();
        this.panels = new THREE.Group();
        this.satellite.add(this.body);
        this.satellite.add(this.panels);

        this.makeFootprints();
        this.selectedBeam = this._selectedBeam; // use setter to initialize
        this.footprintsRect.visible = false;
        this.footprintsEllipse.visible = false;

        this.satelliteSize = this._satelliteSize; // Use setter to initialize scale
 
        //let helper:THREE.AxesHelper = new THREE.AxesHelper(2000);
        //this.latRotGroup.add(helper);    

    }
    public disposeAll(){
        this.disposeMesh(this.body_m);
        this.disposeMesh(this.panel1_m); 
        this.disposeMesh(this.panel2_m); 
        this.disposeMesh(this.cube_m);  
        for (let i=0; i<this.footprintRect_m.length; i++) {
            this.disposeMesh(this.footprintRect_m[i]); 
        }    
    }
    private disposeMesh(meshObj){
        meshObj.geometry.dispose();
        if (meshObj.material instanceof THREE.Material) {
            meshObj.material.dispose()
        } else if (Array.isArray(meshObj.material)) {
            for (const material of meshObj.material) {
                material.dispose()
            }
        } 
    }

    private makeFootprints(){
        let beamWidth_km:number = 1694; //1100;
        let beamLength_km:number = 52; //69;
        
        let footprint_g:THREE.PlaneGeometry = new THREE.PlaneGeometry(beamWidth_km, beamLength_km);
        let footprintCircle_g:THREE.CircleGeometry = new THREE.CircleGeometry(1000, 1000);

        this.footprintRect_m = [];
        let footprintEllipse_m:Array<THREE.Mesh> = [];
        //var footprint_matl:Array<THREE.MeshBasicMaterial> = [];
        this.footprintColorsMulti = ["red","lime","blue","orange","pink","yellow","purple","green","deeppink","aqua","coral","plum","navy","goldenrod","teal","violet"];
        this.footprintColorsGray = ["white","gray","white","gray","white","gray","white","gray","white","gray","white","gray","white","gray","white","#606060"];
        let iBeam:number;
        let xx:number
        for (iBeam = 0; iBeam < this._nBeams; iBeam++){
            this.footprintRect_m[iBeam] = new THREE.Mesh(footprint_g, new THREE.MeshBasicMaterial({color:this.footprintColorsMulti[iBeam]}));
            this.footprintRect_m[iBeam].rotation.y = Math.PI/2;
            this.footprintRect_m[iBeam].position.x = -1150;
            this.footprintRect_m[iBeam].position.y = beamLength_km*(iBeam-8);
            this.footprintsRect.add(this.footprintRect_m[iBeam]);
            this.footprintRect_m[iBeam].name = "beam"+iBeam;

            footprintEllipse_m[iBeam] = new THREE.Mesh(footprintCircle_g, new THREE.MeshBasicMaterial({color:this.footprintColorsMulti[iBeam]}));
            footprintEllipse_m[iBeam].rotation.y = Math.PI/2;
            
            if (UtilSP.isEven(iBeam)){
                xx = -1150;
            } else {
                xx = -1150 + 2; // Stop shimmering
            }
            footprintEllipse_m[iBeam].position.x = xx;
            footprintEllipse_m[iBeam].position.y = beamLength_km*(iBeam-8);
            footprintEllipse_m[iBeam].scale.z = 1.2*beamWidth_km/1000;
            footprintEllipse_m[iBeam].scale.y = 1.2*0.5* beamLength_km/1000; // not sure why it needs this 0.5 factor 
            this.footprintsEllipse.add(footprintEllipse_m[iBeam]);
        }
    }
    public set selectedBeam(val:number){
        this._selectedBeam = val;
        let iBeam:number;
        let col:string;
        let opacity:number;
        for (iBeam = 0; iBeam < this._nBeams; iBeam++){
            if ( this._footprintColorMode == "all"){
                //this.footprintRect_m[iBeam].material = new THREE.MeshBasicMaterial({color:this.footprintColorsMulti[iBeam]});
                col = this.footprintColorsMulti[iBeam];
                opacity = 0.8;
             } else {
                if (iBeam == this._selectedBeam){
                    //this.footprintRect_m[iBeam].material = new THREE.MeshBasicMaterial({color:this.footprintColorsMulti[iBeam]});
                    col = this.footprintColorsMulti[iBeam];
                    opacity = 0.8;
                } else {
                    col = this.footprintColorsGray[iBeam];
                    opacity = 0.5;
                }
            }
            this.footprintRect_m[iBeam].material = new THREE.MeshBasicMaterial({color:col,transparent:true, opacity:opacity});
        }
    }
    private makeDetailedSatellite(){
        UtilSP.clearThreeJSGroup(this.body);
        UtilSP.clearThreeJSGroup(this.panels);

        let bodyShape:THREE.Shape = new THREE.Shape();
        bodyShape.moveTo( -500,-500 );
        bodyShape.lineTo( 500, -500 );
        bodyShape.lineTo( 300, 500 );
        bodyShape.lineTo( -300, 500 );
        bodyShape.lineTo( -500,-500);

        const extrudeSettings = {
            steps: 2,
            depth: 1000,
            bevelEnabled: false,
            bevelThickness: 1,
            bevelSize: 1,
            bevelOffset: 0,
            bevelSegments: 1
        };

        let body_g:THREE.ExtrudeGeometry = new THREE.ExtrudeGeometry( bodyShape, extrudeSettings );
        let body_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( { color: "gold" } );
        this.body_m = new THREE.Mesh( body_g, body_mat ) ;
        this.body_m.rotation.x = Math.PI/2;
        this.body_m.rotation.z = -Math.PI/2;
        this.body_m.position.y = 500;

        let bar_g:THREE.CylinderGeometry = new THREE.CylinderGeometry(20, 20, 2500);
        let bar_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial({color:"gray"});
        let bar_m:THREE.Mesh = new THREE.Mesh(bar_g, bar_mat);
        bar_m.rotation.x = Math.PI/2;   

        let ants:Array<THREE.Mesh> = [];
        let ant_g:THREE.BoxGeometry = new THREE.BoxGeometry(50, 900, 50);
        let ant_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial({color:"brown"});
        let nAnts:number = 9;
        for (let i:number = 0; i<nAnts; i++){
            ants[i] = new THREE.Mesh(ant_g, ant_mat);
            ants[i].position.x = -550;           
            ants[i].position.z = -400 + i*100;           
            this.body.add(ants[i]);
        }

        let gwAnt_g:THREE.CircleGeometry = new THREE.CircleGeometry(150,32);
        let gwAnt_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial({color:"white", side: THREE.DoubleSide});
        let gw1_m:THREE.Mesh = new THREE.Mesh(gwAnt_g, gwAnt_mat);
        gw1_m.position.y = 700;
        gw1_m.position.x = -500;
        gw1_m.position.z = -300;
        gw1_m.rotation.x = Math.PI/2;
        gw1_m.rotation.y = UtilSP.radians(-70);
        let gw2_m:THREE.Mesh = new THREE.Mesh(gwAnt_g, gwAnt_mat);
        gw2_m.position.y = gw1_m.position.y;
        gw2_m.position.x = gw1_m.position.x;
        gw2_m.position.z = -gw1_m.position.z;
        gw2_m.rotation.x = gw1_m.rotation.x;
        gw2_m.rotation.y = gw1_m.rotation.y;            
        this.body.add(gw1_m);
        this.body.add(gw2_m);
        
        this.body.add(this.body_m);
        this.body.add(bar_m);

        let panelHeight:number = 1500;
        let panelWidth:number = 1500;
        let panelThickness:number = 10;
        let panel_g:THREE.BoxGeometry = new THREE.BoxGeometry(panelThickness, panelWidth, panelHeight, 10, 10, 10); //
        let panel_matl:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( {color:"blue", side: THREE.DoubleSide });
        this.panel1_m = new THREE.Mesh(panel_g, panel_matl );
        this.panel2_m = new THREE.Mesh(panel_g, panel_matl );
        this.panels.add(this.panel1_m);
        this.panels.add(this.panel2_m);
        this.panel1_m.position.z = 2000;
        this.panel2_m.position.z = -this.panel1_m.position.z;
    }

    public set panelRotationDeg(val:number){
        this.panels.rotation.z = -UtilSP.radians(val);
    }
    public get panelRotationDeg(){
        return UtilSP.degrees(this.panels.rotation.z);
    }

    public set satelliteSize(val:number){
        this._satelliteSize = val;
        let scale:number = 1;
        if (this._satelliteStyle == "detailed"){
            scale = val/1000; // Body was sized at 1000
        } else {
            scale = val/100; // Cube geometry is 100
        }
        this.satellite.scale.x = scale;
        this.satellite.scale.y = scale;
        this.satellite.scale.z = scale;
    }
    public setPos(xpos:number, ypos:number, zpos:number, ta_deg:number, raan_deg:number){
        this.position.x = xpos;
        this.position.y = ypos;
        this.position.z = zpos;
        // y is north
        // x is parallel to equator

        
        ///var posCartesian:Vector3D = this.position;
        ///var posSpherical:Vector3D;
        ///posSpherical = Util3.cart2azel(posCartesian); // az (deg), lat(deg) - correct, radius - correct
        // TA = 0 at north pole, increases as satellite moves south
        // posSpherical.x = -90 at prime meridian, increases to 180 as moves east, then flips to -180 and continues to increase

        let phiDeg:number = -(ta_deg - 90);
        this.latRotGroup.rotation.z = UtilSP.radians(-phiDeg);
        ///var long:Number = Util3.mod360(posSpherical.x + 90);
        
        this.longRotGroup.rotation.y =  UtilSP.radians(raan_deg); // Long
        //trace("_RAANdeg = "+_RAANdeg+", phiDeg= "+phiDeg+", posCartesian = "+posCartesian+", posSpherical = "+posSpherical+", Lat = "+posSpherical.x+", TA = "+_trueAnomalyDeg);
        // Now satellite -z axis is towards the center of the earth, x acis is parallel to the equator, -y is towards N pole
        
    }
    public set satelliteStyle(val:string){
        //console.log("In set satelliteStyle = "+val);
        if (val != "cube" && val != "detailed"){
            console.log("In OneWebSatellite_grp, set detailed, invaled style ignored: "+val);
            return;
        }
        if (val == this._satelliteStyle) return;

        this._satelliteStyle = val;

        if (this._satelliteStyle == "detailed"){
            this.makeDetailedSatellite();
            this.body.visible = true;
            this.panels.visible = true;   
            this.cubeSat.visible = false;                 
       } else {
            UtilSP.clearThreeJSGroup(this.body);
            UtilSP.clearThreeJSGroup(this.panels);       
            this.body.visible = false;
            this.panels.visible = false;  
            this.cubeSat.visible = true;                  
        }
    }
    public get satelliteStyle(){
        return this._satelliteStyle ;
    }
    public set color(val:string){
        if (this._satelliteStyle == "detailed"){
            let panel_matl:THREE.MeshPhongMaterial;
            let body_mat:THREE.MeshPhongMaterial;
            if (val == "gray"){
                panel_matl = new THREE.MeshPhongMaterial( {color:"gray", side: THREE.DoubleSide });
                body_mat = new THREE.MeshPhongMaterial( { color: "gray" } );
            } else {
                panel_matl = new THREE.MeshPhongMaterial( {color:"blue", side: THREE.DoubleSide });
                body_mat = new THREE.MeshPhongMaterial( { color: "gold" } );
            }
            this.panel1_m.material = panel_matl;
            this.panel2_m.material = panel_matl;
            this.body_m.material = body_mat;

        } else {
            let cube_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial( { color: val } );
            this.cube_m.material = cube_mat;
        }
    }
    public set footprintColorMode(val:string){
        this._footprintColorMode = val;
        let iBeam:number;
        let xx:number
        for (iBeam = 0; iBeam < this._nBeams; iBeam++){
            if ( this._footprintColorMode == "all"){
                this.footprintRect_m[iBeam].material = new THREE.MeshBasicMaterial({color:this.footprintColorsMulti[iBeam],transparent:true, opacity:0.8});
            } else {
                this.footprintRect_m[iBeam].material = new THREE.MeshBasicMaterial({color:this.footprintColorsGray[iBeam],transparent:true, opacity:0.5});

            }
        }        
    }
    public set satName(val:string){
        this._satName = val;
        let iBeam:number;
        for (iBeam = 0; iBeam < this._nBeams; iBeam++){
            this.footprintRect_m[iBeam].name = "Sat_"+this._satName+"_beam"+iBeam;
        }
    }
    public get satName(){
        return this._satName;
    }

    public set footPrintsStyle(val:string){
        this._footPrintsStyle = val;
        switch (this._footPrintsStyle){
            case "none":
                this.footprintsRect.visible = false;
                break;
            case "rect":
                this.footprintsRect.visible = true;
                break;     
            case "ellipse":
                this.footprintsEllipse.visible = true;
                break;                       
        }
        if (val == "none"){
        }
    }
    public get footPrintsStyle(){
        return this._footPrintsStyle;
    }
}


